import { render, staticRenderFns } from "./type9.vue?vue&type=template&id=75d3a88a&scoped=true&"
import script from "./type9.vue?vue&type=script&lang=js&"
export * from "./type9.vue?vue&type=script&lang=js&"
import style0 from "./type9.vue?vue&type=style&index=0&id=75d3a88a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d3a88a",
  null
  
)

export default component.exports